"use client";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Faq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const faqs = [{
    question: "How does the KTEX trading platform work?",
    answer: "KTEX connects verified buyers and suppliers through a streamlined digital marketplace. Our platform facilitates secure negotiations, real-time inventory tracking, and automated trade documentation to ensure seamless global transactions."
  }, {
    question: "What are the requirements to become a verified supplier?",
    answer: "To maintain our high standards, suppliers must provide valid business registration, quality certifications, and a proven track record of fulfillment. Our team reviews every application to ensure reliability for our buyer network."
  }, {
    question: "Is my trade data and payment information secure?",
    answer: "Security is our priority. We utilize enterprise-grade encryption for all communications and financial transactions. Your proprietary trade data is never shared with third parties and is protected by strict privacy protocols."
  }, {
    question: "Can I track my shipments in real-time?",
    answer: "Yes. Once a trade is confirmed, our dashboard provides integrated tracking updates, allowing both buyers and suppliers to monitor shipment status from origin to final destination."
  }, {
    question: "How do I handle disputes or quality issues?",
    answer: "KTEX provides a dedicated resolution center. If a shipment does not meet agreed-upon specifications, our support team mediates the process to ensure a fair outcome based on the original contract terms."
  }, {
    question: "Are there subscription fees for using the platform?",
    answer: "We offer tiered membership plans tailored to your business volume. Basic access is available for all verified users, while premium tiers provide advanced analytics, priority support, and lower transaction fees."
  }];
  return <section data-section-id="6115" id="faqaccordion" className="bg-white text-slate-900 py-24 md:py-32 px-6 md:px-8">
      <div ref={ref} className={`mx-auto max-w-[760px] transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        <div className="text-center mb-14 md:mb-16">
          <h2 className="font-default font-medium text-slate-900" style={{
          fontSize: "clamp(2rem, 3.5vw + 0.5rem, 3.5rem)",
          letterSpacing: "-0.02em",
          lineHeight: 1.08
        }}>
            {"Essential "}
            <em className="font-default not-italic text-blue-900" style={{
            fontStyle: "italic",
            fontVariationSettings: '"slnt" -9'
          }}>
              insights
            </em>
            {" for global traders"}
          </h2>
          <p className="mt-6 text-slate-600 mx-auto max-w-[560px]" style={{
          fontSize: "clamp(1.0625rem, 0.4vw + 1rem, 1.1875rem)",
          lineHeight: 1.6
        }}>
            Everything you need to know about navigating the KTEX marketplace and optimizing your supply chain.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full border-t border-slate-200">
          {faqs.map((faq, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`} className="border-b border-slate-200 last:border-b-0">
              <AccordionTrigger className="py-6 text-left font-default font-semibold text-slate-900 hover:no-underline [&>svg]:hidden group" style={{
            fontSize: "clamp(1.125rem, 0.5vw + 1rem, 1.25rem)",
            lineHeight: 1.35
          }}>
                <span className="flex-1 pr-6">{faq.question}</span>
                <span aria-hidden="true" className="relative inline-flex h-6 w-6 shrink-0 items-center justify-center text-blue-900 transition-transform duration-300 ease-out group-data-[state=open]:rotate-[45deg]">
                  <span className="absolute h-[1.5px] w-4 bg-current" />
                  <span className="absolute h-4 w-[1.5px] bg-current" />
                </span>
              </AccordionTrigger>
              <AccordionContent className="pt-0 pb-7 pr-10">
                <p className="text-slate-600 max-w-[640px]" style={{
              fontSize: "1rem",
              lineHeight: 1.65
            }}>
                  {faq.answer}
                </p>
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}